import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import { getWebComponentName } from '../utils';
// import { Icon } from '@adc/ui-adc'
import Icon from '@adc/ui-core/components/elementals/icon';
const WrappedComponent = props => {
    return React.createElement(Icon, { ...props });
};
const WebComponent = r2wc(WrappedComponent, {
    props: {
        name: 'string',
        color: 'string',
        iconStyle: 'string',
        size: 'string',
    },
});
customElements.define(getWebComponentName('icon'), WebComponent);
